import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/car/park/group/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/car/park/group/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/car/park/group/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/car/park/group/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/car/park/group/update', params,options);

// export const syncCarParkGroup = (params, options) =>
//   request.post('/api/v4ward/car/park/group/sync', qs.stringify(params),options);

// export const updateStatus = (params, options) =>
//   request.post('/api/v4ward/carPlateMatchRule/updateStatus', params,options);

// export const getCarParkList = (params, options) =>
//   request.get('/api/v4ward/car/ParkSpace/getCarParkList', Object.assign({}, options, { params }));

// export const getRegionList = (params, options) =>
//     request.get('/api/v4ward/car/ParkSpace/getRegionList', Object.assign({}, options, { params }));

